
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
// Define la ruta base de los archivos de imagen de Leaflet
L.Icon.Default.imagePath = 'https://unpkg.com/leaflet@1.9.4/dist/images/';